/**
 * Simple build-time feature flags for the admin app.
 * Flip a value and redeploy to change behaviour.
 */
export const FEATURES = {
  /**
   * Show the announcement-card panel inside the artist-facing show form
   * (ShowDetailsForm, so both the show-invite and combined-invite pages). The
   * admin /social-cards page is always available regardless of this flag, and
   * the panel is additionally gated to the accounts in
   * SOCIAL_CARDS_ACCOUNT_SLUGS (resolved server-side for anonymous flows).
   */
  socialCardInArtistFlow: true,
} as const;

/**
 * The Social Cards section (templates, logo, colours, fonts) is hardcoded to
 * Radio Weesper's brand, so it is only shown to these account slugs. The app is
 * multi-tenant; other accounts would otherwise see Radio-Weesper-branded
 * templates. Add a slug here to grant an account access.
 */
export const SOCIAL_CARDS_ACCOUNT_SLUGS: string[] = ['radio-weesper'];

export function isSocialCardsEnabled(accountSlug?: string | null): boolean {
  return !!accountSlug && SOCIAL_CARDS_ACCOUNT_SLUGS.includes(accountSlug);
}
